<template>
   <div class="item">
       <a href="#"
          v-if="title"
          @click="itemOnClicked"
          :id="`item-${id}`"
       >
      <!--v-item-click-->
            <span class="icon-collapse"
                  :class="data.classIcon"
                  :style="data.styleIndent"
            >
            </span>
           <span class="label">{{ title }}</span>
       </a>
       <node v-for="catalog in catalogs"
             :catalogs="catalog.catalog"
             :title="catalog.title"
             :id = "catalog.id"
             :depth="depth+1"
             :page="catalog.page"
             v-show="isCatalogIdExpanded(id) || depth == 0"
       >
       </node>
   </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useDataLoader} from "@/modules/reader/book/dataLoader";
    import {usePaging} from "@/modules/reader/book/paging";
    import {usePpanel}  from "@/modules/reader/ppanel/ppanel";

    export default {
        name:"node",
        props: {
            catalogs: Array,
            title:String,
            depth:Number,
            page:String,
            id:Number
        },
        //custom directive to handle expanding/collapsing the catalog list item
        directives: {
            /*
            "item-click": {
                beforeMount(el, binding, vnode, prevVnode) {

                    let instance = binding.instance;

                    el.addEventListener("click", (e)=> {

                        e.preventDefault();

                        if (e.target.classList && e.target.classList.contains("icon-collapse")) {

                            if (el.parentElement.querySelectorAll(".item").length) {
                                //instance.data.showChildren = ! instance.data.showChildren

                                if (instance.isCatalogIdExpanded(el.id)) {
                                    instance.data.showChildren = false;
                                    instance.removeCatalogExpandedItem(el.id);
                                    el.querySelector(".icon-collapse").classList.remove("icon-node-open");
                                    el.querySelector(".icon-collapse").classList.add("icon-node-close");
                                } else {
                                    instance.data.showChildren = true;
                                    instance.addCatalogExpandedItem(el.id);
                                    console.log("icon-collapse:");
                                    console.log(el.querySelector(".icon-collapse"));
                                    el.querySelector(".icon-collapse").classList.add("icon-node-open");
                                    el.querySelector(".icon-collapse").classList.remove("icon-node-close");
                                }}

                        } else {

                            let targetPage = instance.bookData.pagenames.indexOf(String(instance.page));
                            instance.goToPage(targetPage);
                        }

                    });
                }
            }*/
        },
        setup(props, context) {

            const {pageState, setCurrentPage} = usePaging();
            const {pPanelState, togglePpanel, addCatalogExpandedItem, removeCatalogExpandedItem, isCatalogIdExpanded} = usePpanel();
            const { bookData} = useDataLoader();

            const data = reactive({
                classIcon:computed(()=>{
                    return {
                        'icon-no-node': !props.catalogs,
                        //'icon-node-close': !data.showChildren && props.catalogs,
                        //'icon-node-open': data.showChildren && props.catalogs
                        'icon-node-close': props.catalogs && !isCatalogIdExpanded(props.id),
                        'icon-node-open': props.catalogs && isCatalogIdExpanded(props.id)
                    }
                }),
                styleIndent:computed(()=>{
                    return {
                        marginLeft: `${(props.depth - 1) * 15}px`
                    }
                }),
                //showChildren:false
            })

            const itemOnClicked = (e)=> {

                e.preventDefault();

                if (e.target.classList && e.target.classList.contains("icon-collapse")) {

                    if (e.currentTarget.parentElement.querySelectorAll(".item").length) {

                        let id = parseInt(e.currentTarget.id.split("-")[1]);

                        //instance.data.showChildren = ! instance.data.showChildren
                        if (isCatalogIdExpanded(id)) {
                            //data.showChildren = false;
                            removeCatalogExpandedItem(id);
                        } else {
                            //data.showChildren = true;
                            addCatalogExpandedItem(id);
                        }}

                } else {

                    let targetPage = bookData.pagenames.indexOf(String(props.page));
                    goToPage(targetPage);
                }

            }

            const goToPage =(page) => {
                togglePpanel();
                setCurrentPage(page)
            }

            return {
                data,
                props,
                bookData,
                pPanelState,
                togglePpanel,
                addCatalogExpandedItem,
                removeCatalogExpandedItem,
                isCatalogIdExpanded,
                itemOnClicked,
                goToPage
            }
        }

    }

</script>

<style scoped lang="scss">

    .icon-collapse {
        width:20px;
        height:20px;
        margin:0 10px 0 0;
        background-size:20px 20px !important;
    }

    .icon-no-node {
        background:url(~images/icon_ppanel_item.svg);
    }

    .icon-node-close {
        background:url(~images/icon_ppanel_item_expand.svg);
    }

    .icon-node-open {
        background:url(~images/icon_ppanel_item_collapse.svg);
    }
</style>